import { createAsyncActionTypes } from '../../helpers';

const domain = 'interviews';

const getInterviewsInfo = createAsyncActionTypes(domain, 'getInterviewsInfo');

const sendInterviewInvite = createAsyncActionTypes(domain, 'sendInterviewInvite');

const updateInterview = createAsyncActionTypes(domain, 'updateInterview');

const attachFileToInterview = createAsyncActionTypes(domain, 'attachFileToInterview');

const deleteFileFromInterview = createAsyncActionTypes(domain, 'deleteFileFromInterview');

const downloadFileOfInterview = createAsyncActionTypes(domain, 'downloadFileOfInterview');

const toggleAudioFilesRequired = createAsyncActionTypes(domain, 'toggleAudioFilesRequired');

const transcribeFileOfInterview = createAsyncActionTypes(domain, 'transcribeFileOfInterview');

export default {
  getInterviewsInfo,
  sendInterviewInvite,
  updateInterview,
  attachFileToInterview,
  deleteFileFromInterview,
  downloadFileOfInterview,
  toggleAudioFilesRequired,
  transcribeFileOfInterview,
};
